// Mock data pro Čištění vozidel Kuja

export const services = [
  {
    id: 1,
    name: "Kompletní čištění interiéru",
    description: [
      "Ruční mytí rámů, důkladné vysátí podlahy, koberečků, sedadel a kufru",
      "Tepování sedadel, podlahy, koberečků, kufru a pásů",
      "Čištění parou",
      "Čištění a ošetření plastů a přístrojové desky",
      "Čištění a impregnace všech kožených dílů, sedadel a volantu",
      "Vyčištění stropnice",
      "Mytí a leštění oken",
      "Ochrana všech gumových dílů",
      "Provonění interiéru"
    ],
    price: "od 2500,-",
    icon: "sparkles",
    image: "https://images.unsplash.com/photo-1771491237209-b89bc7290588?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxjYXIlMjBpbnRlcmlvciUyMGRldGFpbGluZyUyMGNsZWFuaW5nJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc3MjcyMjg0NHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Umytí exteriéru",
    description: [
      "Umytí exteriéru",
      "Chemická dekontaminace laku",
      "Aplikace voskové ochrany až na 6 měsíců"
    ],
    price: "od 900,-",
    icon: "droplet",
    image: "https://images.unsplash.com/photo-1761312834150-4beefff097a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxjYXIlMjBleHRlcmlvciUyMHdhc2hpbmclMjBmb2FtJTIwc29hcHxlbnwwfHx8fDE3NzI3MjI4NDR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Umytí kol",
    description: [
      "Umytí kol",
      "Oživení pneumatik"
    ],
    price: "500,-",
    icon: "circle",
    image: "https://images.unsplash.com/photo-1565689876697-e467b6c54da2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxjYXIlMjB3aGVlbCUyMGNsZWFuaW5nJTIwYnJ1c2glMjB3YXNoaW5nfGVufDB8fHx8MTc3MjcyMjg0Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "Základní čištění interiéru",
    description: [
      "Vysátí podlahy, koberečků, sedadel a kufru",
      "Suché čištění sedadel",
      "Vyčištění plastů",
      "Vyčištění volantu",
      "Mytí a leštění oken zevnitř"
    ],
    price: "od 1500,-",
    icon: "wind",
    image: "https://images.unsplash.com/photo-1771491237225-01931a752f58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnRlcmlvciUyMGRldGFpbGluZyUyMGNsZWFuaW5nJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc3MjcyMjg0NHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    name: "Tepování sedadla",
    description: [
      "Profesionální hloubkové čištění sedadel pomocí tepovacího stroje",
      "Odstranění skvrn a nečistot"
    ],
    price: "od 500,-",
    icon: "armchair",
    image: "https://i.ibb.co/xZsHTwK/15747138-5dacd2.webp"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Domin",
    rating: 5,
    text: "Výborná práce! Auto vypadá skvěle, vše je krásně vyčištěné a v top stavu. Profesionální přístup a hlavně férové ceny.",
    location: "Hodonín"
  },
  {
    id: 2,
    name: "Martin Štrokay",
    rating: 5,
    text: "Profesionalita, rychlost, luxusní výsledek",
    location: "Prušánky"
  },
  {
    id: 3,
    name: "Martin Dvořák",
    rating: 4,
    text: "Skvělé služby za rozumné ceny. Pan Kuja je velmi přátelský a pečlivý. Rád se vrátím.",
    location: "Hodonín"
  }
];

export const gallery = [
  {
    id: 1,
    before: "https://i.ibb.co/pvh8RzQh/IMG-6339.jpg",
    after: "https://i.ibb.co/Fqynjf1L/IMG-6348.jpg",
    title: "Čištění interiéru"
  },
  {
    id: 2,
    before: "https://i.ibb.co/hxnfdmMc/IMG-7382.jpg",
    after: "https://i.ibb.co/r2dS9t5c/IMG-7383.jpg",
    title: "Kompletní péče o sedadla"
  },
  {
    id: 3,
    before: "https://i.ibb.co/6R1fFgcd/IMG-7384.jpg",
    after: "https://i.ibb.co/84zcRDyD/IMG-7385.jpg",
    title: "Detailní čištění koberců"
  },
  {
    id: 4,
    before: "https://i.ibb.co/MytnzK2h/IMG-7386.jpg",
    after: "https://i.ibb.co/ccmnKbsP/IMG-7388.jpg",
    title: "Profesionální tepování"
  },
  {
    id: 5,
    before: "https://i.ibb.co/dJWHmMmM/IMG-7389.jpg",
    after: "https://i.ibb.co/svdMwTKt/IMG-7390.jpg",
    title: "Renovace sedadel"
  },
  {
    id: 6,
    before: "https://i.ibb.co/fYNRXnqR/IMG-7399.jpg",
    after: "https://i.ibb.co/1YXJqHSF/IMG-7400.jpg",
    title: "Hloubkové čištění"
  },
  {
    id: 7,
    before: "https://i.ibb.co/LFbXtct/IMG-7405.jpg",
    after: "https://i.ibb.co/5WR9kpc2/IMG-7406.jpg",
    title: "Čištění dveřních panelů"
  },
  {
    id: 8,
    before: "https://i.ibb.co/Nn29YGmm/IMG-7409.jpg",
    after: "https://i.ibb.co/jvRLqm8F/IMG-7412.jpg",
    title: "Péče o textilie"
  },
  {
    id: 9,
    before: "https://i.ibb.co/DPXzLfrs/IMG-7413.jpg",
    after: "https://i.ibb.co/DHC4Ry3q/IMG-7414.jpg",
    title: "Čištění kol a pneumatik"
  }
];

export const contactInfo = {
  phone: "737 173 595",
  email: "adam.kuja21@seznam.cz",
  address: "Příční 29, Prušánky",
  businessName: "Čištění vozidel Kuja",
  slogan: "Vyčistím ti auto, ne peněženku",
  logo: "https://customer-assets.emergentagent.com/job_carwash-kuja/artifacts/cm69ze8b_602332478_122117041305027995_1410885878850610449_n-removebg-preview.png"
};
